import { call, put, takeLatest } from 'redux-saga/effects';

import {
    getTeamDataSuccess,
    getTeamDataFail,
    getCostReportSuccess,
    getCostReportFail,
    getMonthlyReportSuccess,
    getMonthlyReportFail
} from "./action";

import {
    GET_TEAM_DATA_REQUEST,
    GET_COST_REPORT_REQUEST,
    GET_MONTHLY_REPORT_REQUEST
} from "./constants";

import request from 'utils/request';
import { BASE_API_URL } from 'constants/api';

function* getNewsRequest(action) {
    try {
       
        const config = {
            method: 'get',
            url: `${BASE_API_URL}/users`,
        };
        let response = yield call(request, config);

        const attempts_config = {
            method: 'get',
            url: `${BASE_API_URL}/training?trainingId=2`,
        };
        let response_attempts = yield call(request, attempts_config);
        
        yield put(getTeamDataSuccess({users: response.users, attempts: response_attempts}));
    } catch (err) {
        yield put(getTeamDataFail(err));
    }
}

function* getCostReportSaga(action) {
    try {
        const { aggregationType, startDate, endDate, includeUserId, includeTrainingId } = action.payload;
        const aggregateFields = [];
        if (includeUserId) {
            aggregateFields.push("UserId");
        }
        if (includeTrainingId) {
            aggregateFields.push("TrainingId");
        }
        const config = {
            method: 'get',
            url: `${BASE_API_URL}/training/report`,
            params: { aggregationType, startDate, endDate, aggregateFields },
            paramsSerializer: {
                indexes: null
            }
        };

        const response = yield call(request, config);
        yield put(getCostReportSuccess(response.reportItems));
    } catch (err) {
        yield put(getCostReportFail(err));
    }
}

function* getMonthlyReportSaga() {
    try {
        const currentDate = new Date();
        const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        const lastDayOfPreviousMonth = new Date(firstDayOfMonth - 1);
        const firstDayOfPreviousMonth = new Date(lastDayOfPreviousMonth.getFullYear(), lastDayOfPreviousMonth.getMonth(), 1);

        // add a day to the current date because the api will use midnight of the end date
        const currentDatePlusOne = new Date(currentDate);
        currentDatePlusOne.setDate(currentDatePlusOne.getDate() + 1);

        const config = {
            method: 'get',
            url: `${BASE_API_URL}/training/report`,
            params: {
                aggregationType: 2, // Monthly
                startDate: firstDayOfPreviousMonth.toISOString().split('T')[0],
                endDate: currentDatePlusOne.toISOString().split('T')[0],
                aggregateFields: []
            },
            paramsSerializer: {
                indexes: null
            }
        };

        const response = yield call(request, config);
        yield put(getMonthlyReportSuccess(response.reportItems));
    } catch (err) {
        yield put(getMonthlyReportFail(err));
    }
}

export default function* teamSaga() {
    yield takeLatest(GET_TEAM_DATA_REQUEST, getNewsRequest);
    yield takeLatest(GET_COST_REPORT_REQUEST, getCostReportSaga);
    yield takeLatest(GET_MONTHLY_REPORT_REQUEST, getMonthlyReportSaga);
}